// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2UFh9","content":"style_content__39VIK","msg":"style_msg__IEiw7","HomeBtn":"style_HomeBtn__2KLAq"};